import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';
import App from './App';
import './index.css';

// Configure Amplify with outputs from backend deployment
// This file is auto-generated by `ampx sandbox` or `ampx deploy`
import outputs from '../amplify_outputs.json';

// Fix: Amplify Gen 2 doesn't automatically add SAML providers to identity_providers array
// We need to add it manually for signInWithRedirect to work
const configWithSAML = {
  ...outputs,
  auth: {
    ...outputs.auth,
    oauth: {
      ...outputs.auth?.oauth,
      identity_providers: ['rvoh-okta-saml'], // Add SAML provider
    },
  },
};

Amplify.configure(configWithSAML);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
